/* CandidateElection client data model
 *
 * Angular Module: trackerbase-app.models.candidate-election
 * Injected Factory: CandidateElection
 */

 // TODO - Use Office model internally rather than having rolling its own //

import State from "./State";

import makePropsEnumerable from "../utility/MakePropsEnumerable";

// TODO: Remove hard-coded office type names
const abbrevTable = new Map([
    ["President", "Pres"],
    ["Vice President", "VP"],
    ["Senate", "Sen"],
    ["House", "House"],
    ["Governor", "Gov"],
    ["Lt. Governor", "LtGov"],
    ["Secretary of State", "SoS"],
    ["Attorney General", "AG"],
    ["State Legislature", "StLeg"],
    ["Other", "Other"]
]);

function makeLocalDate(dString) {
    let directDate = new Date(dString);
    let uDate = new Date(directDate.getUTCFullYear(), directDate.getUTCMonth(), directDate.getUTCDate());
    return uDate;
}

class CandidateElection {
    constructor(
        targetId,
        startDate,
        endDate,
        electionId,
        electionDate,
        electionOfficeId,
        electionOfficeType,
        electionOfficeDistrict,
        electionState
    )
    {
        this.trackingTargetId = targetId;

        let validDates = false;
        if ((angular.isDefined(startDate)) && (angular.isDefined(endDate))) {
            if ((startDate != null) && (endDate != null)) {
                if ((angular.isDate(startDate)) && (angular.isDate(endDate))) {
                    if (startDate <= endDate) {
                        validDates = true;
                    }
                }
            }
        }

        if (validDates === true) {
            this.startDate = startDate;
            this.endDate = endDate;
        }
        else {
            throw new RangeError("Invalid date range parameters.");
        }

        this.electionId = electionId;
        this.electionDate = electionDate;
        this.electionOfficeId = electionOfficeId;
        this.electionOfficeTypeName = electionOfficeType;
        this.electionOfficeDistrict = electionOfficeDistrict;
        this.electionState = electionState;
    }

    toString() {
        return `${this.electionOfficeTypeName}/${this.electionDate}/${this.electionState}/${this.electionOfficeDistrict}/${this.startDate}/${this.endDate}`;
    }

    valueOf() {
        return parseInt(
            String(this.trackingTargetId) +
            String(this.electionId)
        );
    }

    getElectionOfficeName() {

        if (this.electionOfficeTypeName === "House") {
            return this.electionState.shortName + "-" +
                this.electionOfficeDistrict;
        }
        else {
            return this.electionState.shortName + "-" +
                CandidateElection
                    .OfficeTypeNameAbbreviationTable
                    .get(this.electionOfficeTypeName);
        }
    }

    wasCandidateOnDate(eventDate) {
        return (
            (this.startDate <= eventDate) &&
            (eventDate <= this.endDate)
        );
    }

    static get OfficeTypeNameAbbreviationTable() { return abbrevTable; }
    
    static FromServerCandidateElection(trackingTargetId, serverCndElection) {

        let parsedStartDate = makeLocalDate(serverCndElection.CandidacyStartDate);
        let parsedEndDate = makeLocalDate(serverCndElection.CandidacyEndDate);
        // let parsedElectionDate = makeLocalDate(serverCndElection.Election.ElectionDate);
        //
        // angular.noop(parsedElectionDate);

        let cndElection = new CandidateElection(
            trackingTargetId,
            parsedStartDate,
            parsedEndDate,
            serverCndElection.Election.ElectionId,
            serverCndElection.Election.ElectionDate,
            serverCndElection.Election.ElectionOffice.OfficeId,
            serverCndElection.Election.ElectionOffice.OfficeType.OfficeTypeName,
            serverCndElection.Election.ElectionOffice.District,
            State.FromServerState(
                serverCndElection.Election.ElectionOffice.OfficeState
            )
        );

        return cndElection;
    }
}

makePropsEnumerable(CandidateElection.prototype, [
    "getElectionOfficeName",
    "wasCandidateOnDate"
]);

export default CandidateElection;



//////////////////
// WEBPACK FOOTER
// ./src/models/CandidateElection.js
// module id = uJOe
// module chunks = 1